import NotificationAlert, { Notification } from './NotificationAlert';

export default NotificationAlert;
export type { Notification };
